import { typeCustomType } from "./customType"
import { mutationAddCustomAdmUserType } from "./mutations/mutationAddCustomAdmUserType"
import { mutationAddCustomCustomLineItemType } from "./mutations/mutationAddCustomCustomLineItemType"
import { mutationAddCustomerAddressCustomType } from "./mutations/mutationAddCustomerAddressCustomType"
import { mutationAddCustomerCustomType } from "./mutations/mutationAddCustomerCustomType"
import { mutationAddCustomFieldToCustomLineItemType } from "./mutations/mutationAddCustomFieldToCustomLineItemType"
import { mutationAddCustomCartType } from "./mutations/mutationAddCustomTypeToCart"
import { mutationEditCustomCartType } from "./mutations/mutationEditCustomCartType"

const customTypeSchema = {
  types: [typeCustomType],
  resolvers: {
    Query: {},
    Mutation: {
      ...mutationAddCustomAdmUserType,
      ...mutationAddCustomCustomLineItemType,
      ...mutationAddCustomerAddressCustomType,
      ...mutationAddCustomerCustomType,
      ...mutationAddCustomFieldToCustomLineItemType,
      ...mutationAddCustomCartType,
      ...mutationEditCustomCartType,
    },
  },
}

export default customTypeSchema
